export const DEFAULT_LANGUAGE = 'ro-RO';
export const GENERAL_TOAST_OPTIONS = {
  delay: 1500,
};
export const NAVBAR_HEIGHT = 60;
export const DEFAULT_PAGINATION_SIZE = 10;
export const NOT_APPLICABLE = '-';

export const ACCEPTED_CLIENT_DOCUMENT_TYPES = {
  'application/pdf': ['.pdf'],
};

export const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30MB
